import React from 'react';

const Dashboard = () => (
    <>
        <h1>Freemium</h1>
    </>
);

export default Dashboard;